// @module Tekyard.PDPSerialLotFunctionality.SerialLotData
define('C3.PDPSerialLotFunctionality.SerialLotData.View'
,	[
	'tekyard_pdpseriallotfunctionality_seriallotdata.tpl'
	
	//,	'Tekyard.PDPSerialLotFunctionality.SerialLotData.MainView'
	,   'C3.ShoppingExtensions.PDP.AddToWishlist.View'
	,   'C3.PDPSerialLotFunctionality.WarrantyPopup.View'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.MainView'
	,   'C3.PDPSerialLotFunctionality.LotItemImages.Model'
	,   'C3.PDPSerialLotFunctionality.LotItemImageGallery.View'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.InfoTooltip'
	,	'Backbone'
	,   'Utils'
	,   'LiveOrder.Model'
	,   'C3.PDPSerialLotFunctionality.SerialLotCartConfirmation.View'
	,   'C3.PDPSerialLotFunctionality.SerialLotData.CarouselItems.Model'
	,   'C3.Utils.CartUtils'
    ]
, function (
	tekyard_pdpseriallotfunctionality_seriallotdata_tpl

	//,	SerialLotMainView
	,   AddToWishlistView
	,   WarrantyPopupView
	,   SerialPopupView
	,   LotItemImagesModel
	,   LotItemImageGalleryView
	,   InfoTooltip
	,	Backbone
	,   Utils
	,   LiveOrderModel
	,   SerialLotCartConfirmationView
	,   CarouselItemsModel
	,   CartUtils
)
{
    'use strict';

	// @class Tekyard.PDPSerialLotFunctionality.SerialLotData.View @extends Backbone.View
	return Backbone.View.extend({

		template: tekyard_pdpseriallotfunctionality_seriallotdata_tpl

	,	initialize: function (options) {	
	    this.options = options;	
	    this.application = options.application;
	    this.layout = options.layout;
	    this.model = options.model;
	    this.item = options.item;
	    this.inventorydata = this.model.get('inventorydata') || [];	
	    this.configuration = this.application.getConfig();
		
	    // Determine if this is a Lot item or Serial item
	    this.isLotItem = this.item.islotitem === true || this.item.islotitem === 'T';
	    
	    // Determine if this is a Disposable item (Lot item with custitemisdisposable flag)
	    this.isDisposableItem = (this.item.custitemisdisposable === true || this.item.custitemisdisposable === 'T');
	    
	    var defaultFunctionalCondition = this.configuration.SerialLotDefaultFunctional
	    ,   defaultFunctionalConditionConfig = defaultFunctionalCondition.config
	    ,   defaultCosmeticCondition = this.configuration.SerialLotDefaultCosmetic
	    ,   defaultCosmeticConditionConfig = defaultCosmeticCondition.config

	    ,   excludedFunctionalConditions = this.configuration.SerialLotExcludedFunctionalConditions
	    //,   excludedFunctionalConditionsConfig = excludedFunctionalConditions.config
	    this.excludedFunctionalConditionsConfig = excludedFunctionalConditions.config;
	    this.defaultFunctionalCondition = defaultFunctionalConditionConfig;
	    this.defaultCosmeticCondition = defaultCosmeticConditionConfig;

	    console.log(defaultFunctionalCondition)
	    
	    var self = this;

	    this.filteredInventory = this.inventorydata.filter(function(item) {
	        return !self.excludedFunctionalConditionsConfig.some(function(cond) {
	            return cond.conditionid === item.functionalid;
	        });
	    });

	    // Check if default combination exists in filtered inventory (only for non-disposable items)
	    if (!this.isDisposableItem) {
	        var hasDefault =
	            this.filteredInventory.some(function(item) {
	                return (
	                    item.functionalid && item.cosmeticid &&
	                    item.functionalid.toString() === self.defaultFunctionalCondition.toString() &&
	                    item.cosmeticid.toString() === self.defaultCosmeticCondition.toString()
	                );
	            });

	        if (!hasDefault && this.filteredInventory.length > 0) {
	            var firstAvailable = this.filteredInventory.find(function(item) { 
	                return item.functionalid && item.cosmeticid; 
	            });
	            if (firstAvailable) {
	                this.defaultFunctionalCondition = firstAvailable.functionalid;
	                this.defaultCosmeticCondition = firstAvailable.cosmeticid;
	            }
	        }
	    }

	    this.conditions = this.groupFunctionalAndCosmetic(this.filteredInventory);

	    //console.log(this.configuration)
	    /* ===================== ADD: MASTER CONDITION LISTS ===================== */
	    
	    var fFunctionalCondition = this.configuration.SerialLotFunctionalConditions
	    ,   cCosmeticCondition = this.configuration.SerialLotCosmeticConditions

	    /*this.allFunctionalConditions = [
	        { id: '1', label: 'AA Certified' },
	        { id: '2', label: 'New' },
	        { id: '3', label: 'Refurbished' },
	        { id: '4', label: 'Broken' }
	    ];

	    this.allCosmeticConditions = [
	        { id: '7',  label: 'Excellent' },
	        { id: '8',  label: 'Good' },
	        { id: '9',  label: 'Fair' },
	        { id: '10', label: 'Poor' }
	    ];*/
	    this.allFunctionalConditions = fFunctionalCondition.config;
	    this.allCosmeticConditions = cCosmeticCondition.config;
	    
	    // Disposable Conditions from config
	    var dDisposableCondition = this.configuration.SerialLotDisposableConditions;
	    var defaultDisposableCondition = this.configuration.SerialLotDefaultDisposable;
	    this.allDisposableConditions = dDisposableCondition ? dDisposableCondition.config || [] : [];
	    this.defaultDisposableCondition = defaultDisposableCondition ? defaultDisposableCondition.config : null;
	    
	    // For disposable items, set default if not found
	    if (this.isDisposableItem && this.filteredInventory.length > 0) {
	        var hasDisposableDefault = this.filteredInventory.some(function(item) {
	            return item.disposableid && item.disposableid.toString() === (self.defaultDisposableCondition || '').toString();
	        });
	        if (!hasDisposableDefault) {
	            var firstDisposableItem = this.filteredInventory.find(function(item) { return item.disposableid; });
	            if (firstDisposableItem) {
	                this.defaultDisposableCondition = firstDisposableItem.disposableid;
	            }
	        }
	    }
	    
	    // Cache for lot images (grouped by condition key)
	    this.lotImagesCache = null;
	    this.currentImageRequest = null;  // Track current request to prevent race conditions
	    this.currentLotImageGalleryView = null;  // Track current gallery view for cleanup
	    this.pendingImageRestore = null;  // Track pending restore timeout to prevent duplicates
	    
	    // For Lot items (including Disposable), show loading immediately and then fetch images
	    if (this.isLotItem || this.isDisposableItem) {
	        var self = this;
	        // Delay to ensure PDP image gallery is rendered
	        setTimeout(function() {
	            self.showLotImageLoading();
	            self.updateLotImages();
	        }, 100);
	        
	        // Listen to afterAppendView to restore lot images when native ImageGallery re-renders
	        // (happens on cart confirmation modal, etc.)
	        this.afterAppendViewHandler = function() {
	            // Only restore if:
	            // 1. We have cached images (means initial load completed)
	            // 2. The image gallery container still exists (we're still on PDP)
	            if (self.lotImagesCache && jQuery('[data-view="Product.ImageGallery"]').length) {
	                // Debounce: Clear any pending restore and schedule new one
	                if (self.pendingImageRestore) {
	                    clearTimeout(self.pendingImageRestore);
	                }
	                self.pendingImageRestore = setTimeout(function() {
	                    self.pendingImageRestore = null;
	                    self.updateLotImages();
	                }, 50);
	            }
	        };
	        this.application.getLayout().on('afterAppendView', this.afterAppendViewHandler);
	    }

	    // Track whether all serials for current condition are in cart
	    this.allSerialsInCart = false;

	    // Init Bootstrap tooltips on the info icons after every render. The view
	    // re-renders on every option change, so bind with .on — not .once — to
	    // survive re-renders. All copy + logic lives in the shared InfoTooltip helper.
	    this.on('afterViewRender', function () {
	        InfoTooltip.initInfoTooltips(this.$el);

	        // For serial items, check cart status after DOM is ready
	        if (!this.isLotItem && !this.isDisposableItem) {
	            this.refreshSerialCartStatus();
	        }
	    });
	}


	,	events: {
			'change [data-action="changeOption"]': 'onChangeOption',
			'change [data-action="changeQty"]': 'onChangeQty',
			'change [data-action="changeLotQty"]': 'onChangeLotQty',
			'click [data-action="show-warranty-popup"]': 'showWarrantyPopup',
			'click [data-action="show-serial-popup"]': 'showSerialPopup',
			'click [data-action="add-lot-to-cart"]': 'addLotToCart',
			'click [data-action="add-serial-quick-to-cart"]': 'addSerialQuickToCart'
		}		

	,	bindings: {
		}

	, 	childViews: {
			'AddToProductListSerialLot': function () {
				return new AddToWishlistView({
                   application: this.application,
                   item : this.item,
                   origin : 'seriallot'
                });
		    }
		}

	,   showSerialPopup: function showSerialPopup(e)
		{
			e.preventDefault();

		    var $qtyField = this.$('[data-action="changeQty"]');
		    var $container = $qtyField.closest('[data-validation="control-group"]');


		   // var selectedQty = this.getParam('qty') || 1;
		    let selectedFunctional = this.getParam('functional') || this.defaultFunctionalCondition;
			let selectedCosmetic   = this.getParam('cosmetic')   || this.defaultCosmeticCondition;
			//let selectedProtection = this.getParam('protection') || protectionPlan.find(p => p.default)?.id || null;

			//console.log(this.filteredInventory)
			var view = new SerialPopupView({
				application: this.application,
				layout : this.layout,
				item: this.item,
			//	qty : selectedQty,
				selectedFunctional : selectedFunctional,
				selectedCosmetic : selectedCosmetic,
				functionalConditions : this.finalFunctionalConditions,
				cosmeticConditions : this.finalCosmeticConditions,
				parentView : this,
				filteredInventory : this.filteredInventory
			});

			if (view)
			this.layout.showContent(view, {showInModal: true});
		}
			
	,   showWarrantyPopup: function showWarrantyPopup(e)
		{
			var view = new WarrantyPopupView({
			application: this.application
			});

			if (view)
			this.layout.showContent(view, {showInModal: true});
		}

	,   onChangeLotQty: function onChangeLotQty(e) {
			// Clear any previous error when qty is selected
			this.$('.lot-qty-error').text('');
		}

	,   addLotToCart: function addLotToCart(e) {
			e.preventDefault();
			var self = this;
			var $button = this.$(e.currentTarget);

			// Clear any previous error
			this.$('.lot-qty-error').text('');

			// Read qty directly from dropdown
			var selectedLotQty = parseInt(this.$('[data-action="changeLotQty"]').val(), 10) || 0;

			// Validate qty is selected
			if (!selectedLotQty || selectedLotQty < 1) {
				// Show error message
				this.$('.lot-qty-error').text('Please select a quantity');
				return;
			}

			var matchingInventory;
			var linesData;
			var lotImageUrl = '';
			var cacheKey = '';

			if (this.isDisposableItem) {
				// Disposable items: use disposable condition
				var selectedDisposable = this.getParam('disposable') || this.defaultDisposableCondition;
				
				matchingInventory = this.filteredInventory.find(function(inv) {
					return inv.disposableid && inv.disposableid.toString() === selectedDisposable.toString();
				});

				var disposableName = this.finalDisposableConditions ? this.finalDisposableConditions.find(function(d) { return d.default; }) : null;
				
				// Build cache key for disposable items (remove spaces to match Suitelet key format)
				var disposableLabel = matchingInventory ? (matchingInventory.disposable || '').toLowerCase().replace(/\s+/g, '') : '';
				cacheKey = 'disposable_' + disposableLabel;
				
				// Get first lot image from cache
				if (this.lotImagesCache && this.lotImagesCache[cacheKey] && this.lotImagesCache[cacheKey].length > 0) {
					lotImageUrl = this.lotImagesCache[cacheKey][0].url || '';
				}
				
				// Fallback to item default image
				if (!lotImageUrl) {
					lotImageUrl = this.item.itemimages_detail && this.item.itemimages_detail.urls && this.item.itemimages_detail.urls.length > 0 ? this.item.itemimages_detail.urls[0].url : '';
				}
				
				linesData = {
					assettag: matchingInventory ? matchingInventory.assettag || '' : '',
					imgurl: lotImageUrl,
					location: matchingInventory ? matchingInventory.location || '' : '',
					disposable: disposableName ? disposableName.label : '',
					price: matchingInventory && matchingInventory.saleprice ? matchingInventory.saleprice : ''
				};
			} else {
				// Regular lot items: use functional/cosmetic conditions
				var selectedFunctional = this.getParam('functional') || this.defaultFunctionalCondition;
				var selectedCosmetic = this.getParam('cosmetic') || this.defaultCosmeticCondition;

				matchingInventory = this.filteredInventory.find(function(inv) {
					return inv.functionalid.toString() === selectedFunctional.toString() &&
						   inv.cosmeticid.toString() === selectedCosmetic.toString();
				});

				var functionalName = this.finalFunctionalConditions ? this.finalFunctionalConditions.find(function(f) { return f.default; }) : null;
				var cosmeticName = this.finalCosmeticConditions ? this.finalCosmeticConditions.find(function(c) { return c.default; }) : null;
				
				// Build cache key for lot items (remove spaces to match Suitelet key format)
				var functionalLabel = matchingInventory ? (matchingInventory.functional || '').toLowerCase().replace(/\s+/g, '') : '';
				var cosmeticLabel = matchingInventory ? (matchingInventory.cosmetic || '').toLowerCase().replace(/\s+/g, '') : '';
				cacheKey = functionalLabel + '_' + cosmeticLabel;
				
				// Get first lot image from cache
				if (this.lotImagesCache && this.lotImagesCache[cacheKey] && this.lotImagesCache[cacheKey].length > 0) {
					lotImageUrl = this.lotImagesCache[cacheKey][0].url || '';
				}
				
				// Fallback to item default image
				if (!lotImageUrl) {
					lotImageUrl = this.item.itemimages_detail && this.item.itemimages_detail.urls && this.item.itemimages_detail.urls.length > 0 ? this.item.itemimages_detail.urls[0].url : '';
				}
				
				linesData = {
					assettag: matchingInventory ? matchingInventory.assettag || '' : '',
					imgurl: lotImageUrl,
					location: matchingInventory ? matchingInventory.location || '' : '',
					functional: functionalName ? functionalName.label : '',
					cosmetic: cosmeticName ? cosmeticName.label : '',
					price: matchingInventory && matchingInventory.saleprice ? matchingInventory.saleprice : ''
				};
			}

			if (!matchingInventory) {
				this.$('.lot-qty-error').text('No inventory available for selected condition');
				return;
			}

			var lotNumber = matchingInventory.assettag || '';

			$button.prop('disabled', true).text('Processing...');

			var cart = this.application.getComponent('Cart');
			var conditionData = linesData; // Store for use in confirmation modal
			
			cart.addLine({
				line: {
					quantity: selectedLotQty,
					item: { internalid: parseInt(this.item.internalid, 10) },
					options: [{
						"value": { "label": lotNumber, "internalid": lotNumber },
						"cartOptionId": "custcol_internalassettag",
						"label": "Asset Tag"
					}, {
						"value": { "label": JSON.stringify(linesData), "internalid": JSON.stringify(linesData) },
						"cartOptionId": "custcol_webstore_temp_data",
						"label": "LotData"
					}]
				}
			}).done(function() {
				$button.text('Added to Bag!');
				setTimeout(function() {
					$button.prop('disabled', false).text('Add to Bag');
				}, 2000);

				// Show cart confirmation modal with condition labels
				var cartModel = LiveOrderModel.getInstance();
				var latestLine = cartModel.getLatestAddition();
				
				if (latestLine) {
					var confirmationView = new SerialLotCartConfirmationView({
						application: self.application,
						model: latestLine,
						conditionData: conditionData
					});
					confirmationView.showInModal();
				}
				// Note: Lot images are restored automatically via afterAppendView listener
			}).fail(function(error) {
				console.error('Failed to add lot item to cart:', error);
				$button.prop('disabled', false).text('Add to Bag');
			});
		}

	,   refreshSerialCartStatus: function refreshSerialCartStatus() {
			var self = this;
			var cart = this.application.getComponent('Cart');
			var itemId = String(this.item.internalid);

			cart.getLines().then(function(lines) {
				var selectedFunctional = self.getParam('functional') || self.defaultFunctionalCondition;
				var selectedCosmetic = self.getParam('cosmetic') || self.defaultCosmeticCondition;

				// Get condition labels from filteredInventory (always available, unlike finalFunctionalConditions)
				var matchingInv = self.filteredInventory.find(function(inv) {
					return inv.functionalid.toString() === selectedFunctional.toString() &&
						   inv.cosmeticid.toString() === selectedCosmetic.toString();
				});
				var funcName = matchingInv ? matchingInv.functional : '';
				var cosName = matchingInv ? matchingInv.cosmetic : '';

				var count = 0;
				lines.forEach(function(line) {
					if (String(line.item.internalid) !== itemId) return;
					var tempOpt = _.findWhere(line.options, { cartOptionId: 'custcol_webstore_temp_data' });
					if (!tempOpt) return;
					try {
						var data = JSON.parse(tempOpt.value.internalid);
						if (data.functional === funcName && data.cosmetic === cosName) {
							count++;
						}
					} catch(e) {}
				});

				var availableQty = self.filteredInventory
					.filter(function(item) {
						return item.functionalid.toString() === selectedFunctional.toString() &&
							   item.cosmeticid.toString() === selectedCosmetic.toString();
					})
					.reduce(function(sum, item) { return sum + (parseInt(item.quantityavailable, 10) || 0); }, 0);

				var allInCart = count >= availableQty && availableQty > 0;
				var displayQty = Math.max(availableQty - count, 0);

				self.$('.availability .val, .mobile-availability .val').text(displayQty + ' in Stock');

				if (allInCart !== self.allSerialsInCart) {
					self.allSerialsInCart = allInCart;
					var $btn = self.$('[data-action="add-serial-quick-to-cart"]');
					if (allInCart) {
						$btn.prop('disabled', true).text('Added to Bag');
					} else if (availableQty > 0) {
						$btn.prop('disabled', false).text('Add to Bag');
					}
				}
			});
		}

	,   addSerialQuickToCart: function addSerialQuickToCart(e) {
			e.preventDefault();
			var self = this;
			var $button = this.$(e.currentTarget);

			this.$('.serial-quick-add-error').text('');

			var selectedFunctional = this.getParam('functional') || this.defaultFunctionalCondition;
			var selectedCosmetic = this.getParam('cosmetic') || this.defaultCosmeticCondition;

			var matchingInventory = this.filteredInventory.find(function(inv) {
				return inv.functionalid.toString() === selectedFunctional.toString() &&
					   inv.cosmeticid.toString() === selectedCosmetic.toString();
			});

			if (!matchingInventory) {
				this.$('.serial-quick-add-error').text('No inventory available for selected condition');
				return;
			}

			$button.prop('disabled', true).text('Processing...');

			var carouselModel = new CarouselItemsModel();
			carouselModel.fetch({
				data: {
					itemid: this.item.internalid,
					functional: selectedFunctional,
					cosmetic: selectedCosmetic
				}
			}).done(function(response) {
				var records = response.inventoryrecords || [];

				if (!records.length) {
					self.$('.serial-quick-add-error').text('No serial numbers available for selected condition');
					$button.prop('disabled', false).text('Add to Bag');
					return;
				}

				CartUtils.batchCheckItemsInCart(self.application, self.item.internalid, records)
				.then(function(result) {
					var availableRecords = result.inventoryRecords.filter(function(r) { return !r.inCart; });

					if (!availableRecords.length) {
						var funcLabel = self.finalFunctionalConditions ? self.finalFunctionalConditions.find(function(f) { return f.default; }) : null;
						var cosLabel = self.finalCosmeticConditions ? self.finalCosmeticConditions.find(function(c) { return c.default; }) : null;
						var conditionText = (funcLabel ? funcLabel.label : '') + (cosLabel ? ' / ' + cosLabel.label : '');
						self.$('.serial-quick-add-error').text('All serial numbers for ' + conditionText + ' are already in your bag');
						$button.prop('disabled', false).text('Add to Bag');
						return;
					}

					var serial = availableRecords[0];

					var functionalName = self.finalFunctionalConditions ? self.finalFunctionalConditions.find(function(f) { return f.default; }) : null;
					var cosmeticName = self.finalCosmeticConditions ? self.finalCosmeticConditions.find(function(c) { return c.default; }) : null;

					var imgUrl = serial.inventorynumberimages || '';
					if (!imgUrl) {
						imgUrl = self.item.itemimages_detail && self.item.itemimages_detail.urls && self.item.itemimages_detail.urls.length > 0
							? self.item.itemimages_detail.urls[0].url : '';
					}

					var linesData = {
						assettag: serial.assettag || '',
						imgurl: imgUrl,
						location: serial.locationid || '',
						functional: functionalName ? functionalName.label : '',
						cosmetic: cosmeticName ? cosmeticName.label : '',
						price: serial.saleprice || ''
					};

					var cart = self.application.getComponent('Cart');
					cart.addLine({
						line: {
							quantity: 1,
							item: { internalid: parseInt(self.item.internalid, 10) },
							options: [{
								"value": { "label": serial.assettag, "internalid": serial.assettag },
								"cartOptionId": "custcol_internalassettag",
								"label": "Asset Tag"
							}, {
								"value": { "label": JSON.stringify(linesData), "internalid": JSON.stringify(linesData) },
								"cartOptionId": "custcol_webstore_temp_data",
								"label": "SerialImage"
							}]
						}
					}).done(function() {
						$button.prop('disabled', false).text('Add to Bag');
						self.refreshSerialCartStatus();

						var cartModel = LiveOrderModel.getInstance();
						var latestLine = cartModel.getLatestAddition();

						if (latestLine) {
							var confirmationView = new SerialLotCartConfirmationView({
								application: self.application,
								model: latestLine,
								conditionData: linesData
							});
							confirmationView.showInModal();
						}
					}).fail(function(error) {
						console.error('Failed to add serial item to cart:', error);
						$button.prop('disabled', false).text('Add to Bag');
						self.$('.serial-quick-add-error').text('Failed to add item to cart');
					});
				});
			}).fail(function(error) {
				console.error('Failed to fetch serial details:', error);
				$button.prop('disabled', false).text('Add to Bag');
				self.$('.serial-quick-add-error').text('Unable to find available serial numbers');
			});
		}


	,   removeUrlParam: function (name) {
	    var url = window.location.href;

	    if (url.indexOf('#') > -1) {
	        // Local (hash based)
	        var parts = url.split('#');
	        var base = parts[0];
	        var hash = parts[1] || '';

	        var route = hash.split('?')[0] || '';
	        var params = new URLSearchParams(hash.split('?')[1] || '');

	        // delete param
	        params.delete(name);

	        var newHash = route + (params.toString() ? '?' + params.toString() : '');
	        var newUrl = base + '#' + newHash;
	        window.history.replaceState({}, '', newUrl);
	    } else {
	        // Live (normal params)
	        var liveUrl = new URL(url);
	        liveUrl.searchParams.delete(name);
	        window.history.replaceState({}, '', liveUrl.toString());
	    }
	}

	
	,   onChangeOption: function onChangeOption(e) {
	    var $el = this.$(e.currentTarget);
	    var name = $el.attr('name');   
	    var value = $el.val();

	    this.lastChangedOption = name;

	    this.model.set('selected' + name, value);
	    //console.log(this.model)
	    this.updateUrl(name, value);
	    this.render();

	    // For Lot items (including Disposable), update the main PDP image gallery when conditions change
	    if (this.isLotItem || this.isDisposableItem) {
	        this.updateLotImages();
	    }
	}

	,   updateLotImages: function updateLotImages() {
	    var self = this;
	    var matchingInventory;
	    var cacheKey;
	    var functionalLabel = '';
	    var cosmeticLabel = '';
	    var disposableLabel = '';
	    
	    if (this.isDisposableItem) {
	        // Disposable items: use disposable condition only
	        var selectedDisposable = this.getParam('disposable') || this.defaultDisposableCondition;
	        
	        matchingInventory = this.filteredInventory.find(function(inv) {
	            return inv.disposableid && inv.disposableid.toString() === selectedDisposable.toString();
	        });
	        
	        if (!matchingInventory) {
	            return;
	        }
	        
	        disposableLabel = (matchingInventory.disposable || '').toLowerCase().replace(/\s+/g, '');
	        cacheKey = 'disposable_' + disposableLabel;
	    } else {
	        // Regular lot items: use functional + cosmetic conditions
	        var selectedFunctional = this.getParam('functional') || this.defaultFunctionalCondition;
	        var selectedCosmetic = this.getParam('cosmetic') || this.defaultCosmeticCondition;

	        matchingInventory = this.filteredInventory.find(function(inv) {
	            return inv.functionalid.toString() === selectedFunctional.toString() &&
	                   inv.cosmeticid.toString() === selectedCosmetic.toString();
	        });

	        if (!matchingInventory) {
	            return;
	        }

	        functionalLabel = (matchingInventory.functional || '').toLowerCase().replace(/\s+/g, '');
	        cosmeticLabel = (matchingInventory.cosmetic || '').toLowerCase().replace(/\s+/g, '');
	        cacheKey = functionalLabel + '_' + cosmeticLabel;
	    }
	    
	    // Check cache first
	    if (this.lotImagesCache && this.lotImagesCache[cacheKey]) {
	        var cachedImages = this.lotImagesCache[cacheKey];
	        if (cachedImages.length > 0) {
	            this.updatePDPImageGallery(cachedImages);
	        } else {
	            this.showNoImagesState();
	        }
	        return;
	    }
	    
	    // Get item SKU (name) for folder matching
	    var itemSku = this.item.itemid || this.item.name || '';
	    
	    if (itemSku) {
	        // Show loading before fetch
	        this.showLotImageLoading();
	        
	        // Fetch all images from file cabinet via Suitelet (grouped by condition)
	        this.fetchLotImages(itemSku, function(allImages) {
	            // Cache all images for future condition changes
	            if (allImages) {
	                self.lotImagesCache = allImages;
	                // Look up current condition from cache (works for both lot and disposable)
	                var cachedImages = allImages[cacheKey] || [];
	                if (cachedImages.length > 0) {
	                    self.updatePDPImageGallery(cachedImages);
	                } else {
	                    self.showNoImagesState();
	                }
	            } else {
	                self.showNoImagesState();
	            }
	        });
	    }
	}

	,   fetchLotImages: function fetchLotImages(sku, callback) {
	    var self = this;
	    
	    // Use the LotItemImages Model to fetch images (ensures correct SSP application path)
	    var lotImagesModel = new LotItemImagesModel();
	    
	    // Generate request ID to handle race conditions
	    var requestId = Date.now() + '_' + Math.random();
	    this.currentImageRequest = requestId;
	    
	    lotImagesModel.fetch({
	        data: {
	            sku: sku
	        }
	    }).done(function(response) {
	        // Check if this is still the current request (prevent race condition)
	        if (self.currentImageRequest !== requestId) {
	            return;  // Ignore stale response
	        }
	        
	        if (response.success && response.allImages) {
	            if (callback) {
	                callback(response.allImages);
	            }
	        } else {
	            if (callback) {
	                callback(null);
	            }
	        }
	    }).fail(function(error) {
	        // Check if this is still the current request
	        if (self.currentImageRequest !== requestId) {
	            return;
	        }
	        
	        console.error('Failed to fetch lot images:', error);
	        if (callback) {
	            callback(null);
	        }
	    });
	}

	,   showLotImageLoading: function showLotImageLoading() {
	    // Cleanup previous view if exists
	    this.destroyCurrentLotImageGallery();
	    
	    // Show loading state immediately for lot items
	    var $container = jQuery('[data-view="Product.ImageGallery"]');
	    
	    if ($container.length) {
	        var loadingView = new LotItemImageGalleryView({
	            application: this.application,
	            images: [],
	            isLoading: true
	        });
	        
	        loadingView.render();
	        $container.empty().append(loadingView.$el);
	    }
	}
	
	,   showNoImagesState: function showNoImagesState() {
	    // Cleanup previous view if exists
	    this.destroyCurrentLotImageGallery();
	    
	    var $container = jQuery('[data-view="Product.ImageGallery"]');
	    
	    if ($container.length) {
	        // Show default image when no lot images available
	        var defaultImageHtml = '<div class="product-details-image-gallery">' +
	            '<div class="product-details-image-gallery-detailed-image">' +
	            '<div class="thumbnail-img" style="background-image:url(\'/sca-b2c-2023/img/Default-Image.jpg\')"></div>' +
	            '</div></div>';
	        $container.html(defaultImageHtml);
	    }
	}
	
	,   destroyCurrentLotImageGallery: function destroyCurrentLotImageGallery() {
	    // Cleanup previous gallery view to prevent memory leaks
	    if (this.currentLotImageGalleryView) {
	        try {
	            this.currentLotImageGalleryView.destroy();
	        } catch(e) {}
	        this.currentLotImageGalleryView = null;
	    }
	}

	,   updatePDPImageGallery: function updatePDPImageGallery(images) {
	    var self = this;
	    
	    if (!images || images.length === 0) {
	        this.showNoImagesState();
	        // Clear image URL param when no images
	        this.clearUrlParam('image');
	        return;
	    }
	    
	    // Cleanup previous view
	    this.destroyCurrentLotImageGallery();
	    
	    // Format images for the gallery
	    var formattedImages = images.map(function(img) {
	        return {
	            url: img.url || '',
	            altimagetext: img.name || ''
	        };
	    });
	    
	    // Store first image URL in URL params for Add to Cart/Quote popups
	    if (formattedImages.length > 0 && formattedImages[0].url) {
	        this.updateUrl('image', encodeURIComponent(formattedImages[0].url));
	    }
	    
	    // Find the image gallery container
	    var $container = jQuery('[data-view="Product.ImageGallery"]');
	    
	    if ($container.length) {
	        // Create our custom LotItemImageGallery view
	        var lotImageGalleryView = new LotItemImageGalleryView({
	            application: this.application,
	            images: formattedImages,
	            isLoading: false
	        });
	        
	        // Store reference for cleanup
	        this.currentLotImageGalleryView = lotImageGalleryView;
	        
	        lotImageGalleryView.render();
	        
	        // Replace the container content
	        $container.empty().append(lotImageGalleryView.$el);
	        
	        // Initialize the slider and zoom after DOM is updated
	        setTimeout(function() {
	            lotImageGalleryView.initSliderZoom(true);
	        }, 100);
	    }
	}

	,   updateUrl: function updateUrl(name, value) {
	    var url = window.location.href;

	    if (url.indexOf('#') > -1) {
	        // -------- Local (hash based) --------
	        var parts = url.split('#');
	        var base = parts[0];
	        var hash = parts[1] || '';

	        var route = hash.split('?')[0] || '';
	        var params = new URLSearchParams(hash.split('?')[1] || '');

	        // update/set param
	        params.set(name, value);

	        var newHash = route + '?' + params.toString();
	        var newUrl = base + '#' + newHash;

	        window.history.replaceState({}, '', newUrl);
	    } else {
	        // -------- Live (normal URL params) --------
	        var liveUrl = new URL(url);
	        liveUrl.searchParams.set(name, value);
	        window.history.replaceState({}, '', liveUrl.toString());
	    }
	}



	, formatPrice: function formatPrice(value) {
		    var num = parseFloat(value);
		    if (isNaN(num) || num === 0) {
		        return "$0";
		    }
		    // Remove .00 if whole number
		    var formatted = Number.isInteger(num) ? num.toString() : num.toFixed(2);

		    if (num > 0) {
		        return "+$" + formatted;
		    }
		    return "-$" + Math.abs(formatted);
		}


	, groupFunctionalAndCosmetic: function groupFunctionalAndCosmetic(data) {
	      	var functionalMap = {};
	        var cosmeticMap = {};
	        var self = this;
	        data.forEach(function (item) {
	            // Functional
	            if (item.functionalid && !(item.functionalid in functionalMap)) {
	                var functionalObj = {
	                    id: item.functionalid,
	                    label: item.functional,
	                    price: self.formatPrice(item.functionalprice)
	                };
	                if (item.functionalid === self.defaultFunctionalCondition) { //3 is As Is
	                    functionalObj.default = true;
	                }
	                functionalMap[item.functionalid] = functionalObj;
	            }

	            // Cosmetic
	            if (item.cosmeticid && !(item.cosmeticid in cosmeticMap)) {
	                var cosmeticObj = {
	                    id: item.cosmeticid,
	                    label: item.cosmetic,
	                    price: self.formatPrice(item.cosmeticprice)
	                };
	                if (item.cosmeticid === self.defaultCosmeticCondition) { //3 is Good
	                    cosmeticObj.default = true;
	                }
	                cosmeticMap[item.cosmeticid] = cosmeticObj;
	            }
	        });

	        return {
	            functional: Object.values(functionalMap),
	            cosmetic: Object.values(cosmeticMap)
	        };
	  }	

	,  getParam : function getParam(name) {
			    const url = new URL(window.location.href);
			    let value = url.searchParams.get(name);
			    if (!value) {
			        const hash = window.location.hash || '';
			        if (hash.includes('?')) {
			            const hashParams = new URLSearchParams(hash.split('?')[1]);
			            value = hashParams.get(name);
			        }
			    }
			    return value;
			} 

	, autoSwitchOption: function autoSwitchOption(name, value) {
	    var url = window.location.href;

	    if (url.indexOf('#') > -1) {
	        var parts = url.split('#');
	        var base = parts[0];
	        var hash = parts[1] || '';
	        var route = hash.split('?')[0] || '';
	        var params = new URLSearchParams(hash.split('?')[1] || '');

	        params.set(name, value);
	        window.history.replaceState({}, '', base + '#' + route + '?' + params.toString());
	    } else {
	        var liveUrl = new URL(url);
	        liveUrl.searchParams.set(name, value);
	        window.history.replaceState({}, '', liveUrl.toString());
	    }
	}


	,   setInitialParamsIfMissing: function(paramsObj) {
        var url = window.location.href;

        if (url.indexOf('#') > -1) {
            // hash-based
            var parts  = url.split('#');
            var base   = parts[0];
            var hash   = parts[1] || '';

            var route  = hash.split('?')[0] || '';
            var qs     = hash.split('?')[1] || '';
            var params = new URLSearchParams(qs);

            _.each(paramsObj, function(value, key) {
                if (!params.has(key)) {
                    params.set(key, value);
                }
            });

            var newHash = route + (params.toString() ? '?' + params.toString() : '');
            window.history.replaceState({}, '', base + '#' + newHash);
        } else {
            // normal querystring
            var liveUrl = new URL(url);
            _.each(paramsObj, function(value, key) {
                if (!liveUrl.searchParams.has(key)) {
                    liveUrl.searchParams.set(key, value);
                }
            });
            window.history.replaceState({}, '', liveUrl.toString());
        }
    }
		
		//@method getContext @return Tekyard.PDPSerialLotFunctionality.SerialLotData.View.Context
	,   getContext: function getContext()
    {
        const protectionPlan = [
            { id: '1', label: 'AA Plan', price: '+$200', default: false },
            { id: '2', label: 'None',   price: '+$0',   default: true }
        ];

        let selectedProtection = this.getParam('protection') || protectionPlan.find(p => p.default)?.id || null;
        
        // Variables for final inventory row and availability
        let finalArr = null;
        let availableQty = 0;
        let displayPrice = '';
        
        /* ===================== DISPOSABLE ITEMS HANDLING ===================== */
        
        if (this.isDisposableItem) {
            // Disposable items: single condition type
            let selectedDisposable = this.getParam('disposable') || this.defaultDisposableCondition;
            
            // Auto-switch to valid disposable if current is invalid
            const isCurrentDisposableValid = this.filteredInventory.some(
                inv => inv.disposableid && inv.disposableid.toString() === selectedDisposable.toString()
            );
            
            if (!isCurrentDisposableValid && this.filteredInventory.length > 0) {
                const firstValidDisposable = this.filteredInventory.find(inv => inv.disposableid);
                if (firstValidDisposable) {
                    this.autoSwitchOption('disposable', firstValidDisposable.disposableid);
                    selectedDisposable = firstValidDisposable.disposableid;
                }
            }
            
            // Set initial URL params
            if (this.setInitialParamsIfMissing) {
                this.setInitialParamsIfMissing({
                    disposable: selectedDisposable
                });
            }
            
            // Find matching inventory for disposable
            finalArr = this.filteredInventory.find(
                item => item.disposableid && item.disposableid.toString() === selectedDisposable.toString()
            ) || null;
            
            // Build disposable availability map
            const disposableHasInventoryMap = {};
            (this.allDisposableConditions || []).forEach(disp => {
                disposableHasInventoryMap[disp.id.toString()] = false;
            });
            this.filteredInventory.forEach(inv => {
                if (inv.disposableid) {
                    disposableHasInventoryMap[inv.disposableid.toString()] = true;
                }
            });
            
            // Build final disposable conditions
            this.finalDisposableConditions = (this.allDisposableConditions || []).map(item => {
                const dispId = item.id.toString();
                
                const combos = this.filteredInventory.filter(
                    inv => inv.disposableid && inv.disposableid.toString() === dispId
                );
                
                const stock = combos.reduce(
                    (sum, inv) => sum + (parseInt(inv.quantityavailable, 10) || 0),
                    0
                );
                
                const dynamicPrice = combos.length
                    ? this.formatPrice(combos[0].disposableprice || 0)
                    : "";
                
                return {
                    id: item.id,
                    label: item.label,
                    price: dynamicPrice,
                    stock: stock,
                    default: dispId === selectedDisposable.toString(),
                    disabled: !disposableHasInventoryMap[dispId]
                };
            });
            
            // Calculate available qty for disposable
            availableQty = this.filteredInventory
                .filter(item => item.disposableid && item.disposableid.toString() === selectedDisposable.toString())
                .reduce((sum, item) => sum + (parseInt(item.quantityavailable, 10) || 0), 0);
            
            // Calculate price
            let protectionPrice = protectionPlan.find(p => p.id.toString() === selectedProtection.toString())?.price || "$0";
            protectionPrice = parseFloat(protectionPrice.replace(/[^0-9.-]+/g, "")) || 0;
            let inventoryPrice = finalArr ? parseFloat(finalArr.saleprice) : 0;
            let finalSalePrice = inventoryPrice + protectionPrice;
            displayPrice = Utils.formatCurrency(finalSalePrice);
            
            const quantityOptions = Array.from({ length: availableQty }, (_, i) => i + 1);
            
            const finalProtectionConditions = protectionPlan.map(item => ({
                ...item,
                default: item.id.toString() === selectedProtection.toString()
            }));
            
            let selectedQty = this.getParam('qty') || '';
            
            return {
                disposableConditions: this.finalDisposableConditions,
                currentDisposableCondition: finalArr ? finalArr.disposable : '',
                functionalConditions: null,
                cosmeticConditions: null,
                currentFunctionalCondition: '',
                currentCosmeticCondition: '',
                finalProtectionConditions: finalProtectionConditions,
                salePrice: displayPrice,
                quantityOptions: quantityOptions,
                availableQty: availableQty,
                selectedQty: selectedQty,
                isKitItem: this.item.itemtype == "Kit",
                itemRecPrice: Utils.formatCurrency(this.item.onlinecustomerprice),
                PDPSerialLotFunctionality: this.item.custitem_pdp_seriallot_number_function,
                isPhoneDevice: Utils.isPhoneDevice(),
                isLotItem: this.isLotItem,
                isDisposableItem: this.isDisposableItem
            };
        }
        
        /* ===================== REGULAR LOT/SERIAL ITEMS HANDLING ===================== */

        let selectedFunctional = this.getParam('functional') || this.defaultFunctionalCondition;
        let selectedCosmetic   = this.getParam('cosmetic')   || this.defaultCosmeticCondition;

        /* ===================== AUTO-SWITCH INVALID SELECTION (DIRECTION AWARE) ===================== */

        const isCurrentComboValid = this.filteredInventory.some(
            inv =>
                inv.functionalid.toString() === selectedFunctional.toString() &&
                inv.cosmeticid.toString()   === selectedCosmetic.toString()
        );

        if (!isCurrentComboValid) {

            if (this.lastChangedOption === 'functional') {
                const validCosmetic = this.allCosmeticConditions.find(cos =>
                    this.filteredInventory.some(inv =>
                        inv.functionalid.toString() === selectedFunctional.toString() &&
                        inv.cosmeticid.toString()   === cos.id.toString()
                    )
                );
                if (validCosmetic) {
                    this.autoSwitchOption('cosmetic', validCosmetic.id);
                    selectedCosmetic = validCosmetic.id;
                }

            } else if (this.lastChangedOption === 'cosmetic') {
                const validFunctional = this.allFunctionalConditions.find(func =>
                    this.filteredInventory.some(inv =>
                        inv.cosmeticid.toString()   === selectedCosmetic.toString() &&
                        inv.functionalid.toString() === func.id.toString()
                    )
                );
                if (validFunctional) {
                    this.autoSwitchOption('functional', validFunctional.id);
                    selectedFunctional = validFunctional.id;
                }

            } else {
                const validCosmetic = this.allCosmeticConditions.find(cos =>
                    this.filteredInventory.some(inv =>
                        inv.functionalid.toString() === selectedFunctional.toString() &&
                        inv.cosmeticid.toString()   === cos.id.toString()
                    )
                );
                if (validCosmetic) {
                    this.autoSwitchOption('cosmetic', validCosmetic.id);
                    selectedCosmetic = validCosmetic.id;
                }
            }
        }

        /* ===================== ENSURE URL REFLECTS FINAL VALID COMBO ===================== */

        if (this.setInitialParamsIfMissing) {
            this.setInitialParamsIfMissing({
                functional: selectedFunctional,
                cosmetic:   selectedCosmetic
            });
        }

        /* ===================== FIND FINAL INVENTORY ROW ===================== */

        finalArr = this.filteredInventory.find(
            item =>
                item.functionalid.toString() === selectedFunctional.toString() &&
                item.cosmeticid.toString()   === selectedCosmetic.toString()
        ) || null;

        /* ===================== AVAILABILITY MAPS ===================== */

        const cosmeticHasAnyComboMap = {};
        const functionalHasAnyComboMap = {};

        this.allCosmeticConditions.forEach(cos => {
            cosmeticHasAnyComboMap[cos.id.toString()] = false;
        });

        this.allFunctionalConditions.forEach(func => {
            functionalHasAnyComboMap[func.id.toString()] = false;
        });

        this.filteredInventory.forEach(inv => {
            cosmeticHasAnyComboMap[inv.cosmeticid.toString()] = true;
            functionalHasAnyComboMap[inv.functionalid.toString()] = true;
        });

        /* ===================== FUNCTIONAL CONDITIONS (NOW SYMMETRIC) ===================== */

        this.finalFunctionalConditions = this.allFunctionalConditions.map(item => {
            const combo = this.filteredInventory.find(
                inv =>
                    inv.functionalid.toString() === item.id.toString() &&
                    inv.cosmeticid.toString()   === selectedCosmetic.toString()
            );

            const dynamicPrice = combo
                ? this.formatPrice(combo.functionalprice)
                : "";

            return {
                id: item.id,
                label: item.label,
                price: dynamicPrice,
                default: item.id.toString() === selectedFunctional.toString(),
                disabled: !functionalHasAnyComboMap[item.id.toString()],
                currentFunctionalCondition: item.label
            };
        });

        /* ===================== COSMETIC CONDITIONS (UNCHANGED, SYMMETRIC) ===================== */

        this.finalCosmeticConditions = this.allCosmeticConditions.map(item => {
            const cosId = item.id.toString();

            const combos = this.filteredInventory.filter(
                inv =>
                    inv.cosmeticid.toString()   === cosId &&
                    inv.functionalid.toString() === selectedFunctional.toString()
            );

            const stock = combos.reduce(
                (sum, inv) => sum + (parseInt(inv.quantityavailable, 10) || 0),
                0
            );

            const dynamicPrice = combos.length
                ? this.formatPrice(combos[0].cosmeticprice)
                : "";

            return {
                id: item.id,
                label: item.label,
                price: dynamicPrice,
                stock: stock,
                default: cosId === selectedCosmetic.toString(),
                disabled: !combos.length,
                currentCosmeticCondition : item.label
            };
        });

        /* ===================== QUANTITY ===================== */

        availableQty = this.filteredInventory
            .filter(item =>
                item.functionalid.toString() === selectedFunctional.toString() &&
                item.cosmeticid.toString()   === selectedCosmetic.toString()
            )
            .reduce((sum, item) => sum + (parseInt(item.quantityavailable, 10) || 0), 0);

        const quantityOptions = Array.from({ length: availableQty }, (_, i) => i + 1);

        /* ===================== PROTECTION ===================== */

        const finalProtectionConditions = protectionPlan.map(item => ({
            ...item,
            default: item.id.toString() === selectedProtection.toString()
        }));

        /* ===================== PRICE ===================== */

        let protectionPrice = finalProtectionConditions.find(p => p.default)?.price || "$0";
        protectionPrice = parseFloat(protectionPrice.replace(/[^0-9.-]+/g, "")) || 0;

        let inventoryPrice = finalArr ? parseFloat(finalArr.saleprice) : 0;
        let finalSalePrice = inventoryPrice + protectionPrice;
        displayPrice = Utils.formatCurrency(finalSalePrice);

        let selectedQty = this.getParam('qty') || '';

        var hasAnyStock = this.filteredInventory.some(function(inv) {
            return (parseInt(inv.quantityavailable, 10) || 0) > 0;
        });

        //console.log(hasAnyStock)
        var bogoConfig = this.configuration.PRODUCTPAGEBOGO || {};
        var bogoItemsList = bogoConfig.config || [];
        var showBOGO = false;
        var currentItemId = String(this.item.internalid);
        for (var b = 0; b < bogoItemsList.length; b++) {
            if (String(bogoItemsList[b].itemid) === currentItemId) {
                showBOGO = true;
                break;
            }
        }

        return {
            functionalConditions: this.finalFunctionalConditions,
            cosmeticConditions: this.finalCosmeticConditions,
            disposableConditions: null,
            currentDisposableCondition: '',
            finalProtectionConditions: finalProtectionConditions,
            currentFunctionalCondition: finalArr ? finalArr.functional : '',
            currentCosmeticCondition: finalArr ? finalArr.cosmetic : '',
            salePrice: displayPrice,
            quantityOptions: quantityOptions,
            availableQty: availableQty,
            selectedQty: selectedQty,
            isKitItem : this.item.itemtype == "Kit",
            itemRecPrice : Utils.formatCurrency(this.item.onlinecustomerprice),
            PDPSerialLotFunctionality : this.item.custitem_pdp_seriallot_number_function,
            isPhoneDevice : Utils.isPhoneDevice(),
            isLotItem: this.isLotItem,
            isDisposableItem: this.isDisposableItem,
            allSerialsInCart: this.allSerialsInCart,
            hasAnyStock: hasAnyStock,
            showBOGO: showBOGO
        };
    }

    // Cleanup event listeners to prevent memory leaks
,   destroy: function destroy() {
        // Clear any pending image restore timeout
        if (this.pendingImageRestore) {
            clearTimeout(this.pendingImageRestore);
            this.pendingImageRestore = null;
        }
        // Remove afterAppendView listener
        if (this.afterAppendViewHandler) {
            this.application.getLayout().off('afterAppendView', this.afterAppendViewHandler);
            this.afterAppendViewHandler = null;
        }
        // Cleanup current lot image gallery view
        this.destroyCurrentLotImageGallery();
        // Call parent destroy
        Backbone.View.prototype.destroy.apply(this, arguments);
    }

	});
});
